/**
 * @summary - Component that Provides Generic axios Functionality
 * @author vengateshwaran k
 * @since 2024-08-14
 */
import { getAuthToken } from "../../utility/tokenUtility";
import axios from "axios";

async function request(URL, PARAMS = {}, METHOD = 'GET', resType = 'json', isFileExtract = false, isAuthendication = false) {
  let options = {};
  const token = getAuthToken("id_token");
  if (isFileExtract) {
    options = {
      url: URL,
      method: METHOD,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': "application/pdf",
      },
      responseType: 'arraybuffer',
      credentials: 'include',
    };
  } else if (METHOD !== "GET"){
    options = {
      url: URL,
      method: METHOD,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'text/plain',
      },
      data: PARAMS,
    };
  }

  if (METHOD === "GET") {
    options = {
      url: URL,
      method: METHOD,
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    };
  }

  function generateErrorResponse(message, code) {
    const response = {
      status: 'error',
      message,
    };
    return code ? { ...response, code } : response;
  }

  try {
    const response = METHOD === 'GET' ? await axios.get(URL, options) : await axios.request(options);
    const result =response ;

    if (response.status >= 400) {
      const msg = typeof result === 'string' ? result : 'The server responded with an unexpected status.';
      return generateErrorResponse(msg);
    }

    // handle errors that return with a 200 status
    if (result.message_type === 'error') {
      const msg = response.reason || result.reason || 'An error occurred fetching resources.';
      const { code } = result;
      return generateErrorResponse(msg, code);
    }

    return result;
  } catch (error) {
    if (error?.response) {
      return error?.response;
    }
    return generateErrorResponse('An error occurred fetching resources.');
  }
}

function get(url) {
  return request(url);
}

function post(url, params) {
  return request(url, params, 'POST');
}

function authPost(url, params) {
  return request(url, params, 'POST', 'json', false, true);
}

function update(url, params) {
  return request(url, params, 'PUT');
}

function remove(url, params) {
  return request(url, params, 'DELETE');
}

/**
 * endpoint is only used to download extract files
 */
function getFile(url, params) {
  return request(url, params, 'GET', 'file', true);
}

const Axios = {
  get,
  post,
  update,
  remove,
  getFile,
  authPost,
};

export default Axios;
